const STORAGE_KEY = 'trinity.attendance.checkinFilterByScheduleTime';

export const readCheckinFilterByScheduleTime = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const writeCheckinFilterByScheduleTime = (value: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
  } catch {
    // Blocked storage — preference lasts for this session only.
  }
};
